import { InteractionRequiredAuthError } from '@azure/msal-browser';

import { getMsalInstance } from 'auth/msalInstance';
import { configuration } from 'util/configurations';

/**
 * Acquires an Entra ID access token for the punchout-customer-bff resource.
 * Attempts a silent acquisition first and falls back to an interactive popup when
 * MSAL reports that user interaction is required. Returns an empty string when no
 * account is signed in or acquisition fails.
 */
export async function getAccessToken(): Promise<string> {
  const apiScope = configuration.apiScope?.trim();
  const scopes = apiScope ? [apiScope] : configuration.scopes;

  const msalInstance = getMsalInstance();
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) return '';
  const account = accounts[0];

  try {
    const response = await msalInstance.acquireTokenSilent({ scopes, account });
    return response.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      try {
        const response = await msalInstance.acquireTokenPopup({
          scopes,
          account
        });
        return response.accessToken;
      } catch (popupError) {
        // eslint-disable-next-line no-console
        console.error('acquireTokenPopup failed', popupError);
        return '';
      }
    }
    // eslint-disable-next-line no-console
    console.error('acquireTokenSilent failed', error);
    return '';
  }
}
